import React, { Fragment, useEffect, useState } from "react";
import Row from "canvas-core-react/lib/Row";
import Column from "canvas-core-react/lib/Column";
import Margin from "canvas-core-react/lib/Margin";
import TextHeadline from "canvas-core-react/lib/TextHeadline";
import TextInput from "../../components/enhanced-text-input/enhanced-text-input";
import PrimaryButton from "canvas-core-react/lib/PrimaryButton";
import ContinueButton from "canvas-core-react/lib/ContinueButton";
import Grid from "canvas-core-react/lib/Grid";
import BannerMobile from "./banner/Mobile";
import BannerWeb from "./banner/Web";
import { RetryErrorComponent } from "../../components";

import "./RutStep.scss";

import { useAppContext } from "../../context/AppContext";

import { formatIdserial, formatRut } from "../../utils/formatters";
import { validateRut } from "../../utils/validators";
import { checkout } from "cldffecop-tagging-utils";
import { WealthService } from "../../services/";
import Checkbox from "canvas-core-react/lib/Checkbox";
import TextBody from "canvas-core-react/lib/TextBody";

const RutStep = () => {
  const [state, setState] = useState({
    rut: "",
    idSerial: "",
    errors: {},
  });

  const [consent, setConsent] = useState({
    auth_type: "",
    consent_text: "Cargando...",
    creation_time: "",
    is_active: "",
    sign_provider: "",
    version: "",
  });

  const wealthService = new WealthService();

  const {
    state: context,
    changeItem: setContext,
    displayError,
  } = useAppContext();

  const getConsent = () => {
    setContext({ loading: true });
    wealthService
      .consent({
        channel: "WPUB",
        product: "WEALTH",
        flowType: "ONBOARDING_WEALTH_CUSTOMER",
        consentType: "GENERAL",
        productName: "GENERAL_DATA",
      })
      .then((res) => {
        let value = res;
        let row = value[0];
        setConsent({
          auth_type: row.auth_type,
          consent_text: row.consent_text,
          creation_time: row.creation_time,
          is_active: row.is_active,
          sign_provider: row.sign_provider,
          version: row.version,
        });
      })
      .catch((error) => {
        displayError(
          error,
          getConsent,
          <RetryErrorComponent retryCallBack={getConsent} />
        );
      })
      .finally(() => {
        setContext({ loading: false });
      });
  };

  useEffect(() => {
    getConsent();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const changeItem = (item) => (input) => {
    const { error = {}, value = "" } = input;

    let values = {};

    setState((prevState) => ({
      ...prevState,
      [item]: value,
      ...values,
      errors: { ...prevState.errors, [item]: error },
    }));
  };

  const changeChecked = (input) => {
    setContext({
      checkedStep: {
        ...context.checkedStep,
        stepRut: input,
      },
    });
  };

  const rutChange = (event) => {
    const { value = "" } = event.target;
    const splittedValue = value.split("-");
    let end = "";
    let start = "";
    if (splittedValue.length > 1) {
      start = splittedValue[0].replace(/[^0-9]/g, "");
      end = splittedValue[1].replace(/[^kK0-9]/g, "");
    } else {
      start = value.substring(0, value.length - 1);
      end = value.charAt(value.length - 1);
    }

    const rutWithoutFormat = start + end;
    const isValid = validateRut(start + "-" + end);
    const error = rutWithoutFormat.length < 5 || !isValid ? "RUT inválido" : "";

    changeItem("rut")({ value: rutWithoutFormat, error });
  };

  const idSerialChange = (event) => {
    const idSerial = event.target.value;
    let error = "";
    const value = formatIdserial(idSerial);
    const pattern = /\d{10}/;
    if (pattern.test(value) || value.length < 9)
      error = "Nº de serie incorrecto";
    changeItem("idSerial")({ value, error });
  };

  const validateRutClient = async () => {
    setContext({ loading: true });

    await wealthService
      .consentSave({
        customer_id: formatRut(state.rut).replace(/\./g, ""),
        customer_ip: "",
        channel_type: "WPUB",
        product_type: "WEALTH",
        flow_type: "ONBOARDING_WEALTH_CUSTOMER",
        consent_type: "GENERAL",
        product_name: "GENERAL_DATA",
        version: consent.version,
      })
      .then((res) => {})
      .catch((error) => {
        displayError(error, validateRutClient);
      });

    await wealthService
      .prospect({
        prospect_id: formatRut(state.rut).replace(/\./g, ""),
      })
      .then((res1) => {
        setContext({
          subjectId: res1.subject_id,
        });
        wealthService.prospectInformation(res1.subject_id).then((res2) => {
          let clientValidate = res2;
          setContext({
            subjectData: {
              ...context.subjectData,
              document_number: state.idSerial,
              rut: state.rut,
              name: clientValidate.first_name + " " + clientValidate.last_name,
            },
            loading: false,
            clientStep: "stepContactability",
            productsData: clientValidate.products,
          });
          checkout({
            rut: clientValidate.customer_id,
            step: "1",
            stepName: "step-rut",
            extraDimension: {
              step: "1",
              subjectData: {
                document_number: clientValidate.document_number,
                rut: clientValidate.customer_id,
                name:
                  clientValidate.first_name + " " + clientValidate.last_name,
                email: clientValidate.email,
                phone: clientValidate.phone,
              },
            },
          });
        });
      })
      .catch((error) => {
        displayError(error, validateRutClient);
      })
      .finally(() => {
        setContext({ loading: false });
      });
  };

  return (
    <Fragment>
      <div className={"rut-step"}>
        <BannerMobile />
        <BannerWeb />
        <Grid className={"container-step-web"}>
          <Row>
            <Column xs={4} sm={8} md={8} mdOffset={2} lg={8} lgOffset={2}>
              <Row>
                <Column>
                  <Margin
                    xs={[24, 0, 36, 0]}
                    sm={[24, 0, 36, 0]}
                    md={[24, 0, 36, 0]}
                    lg={[24, 0, 36, 0]}
                  >
                    <TextHeadline id="title-form" component="h1" size="small">
                      Completa los siguientes datos para continuar
                    </TextHeadline>
                  </Margin>
                </Column>
              </Row>
              <Row>
                <Column xs={4} sm={8} md={6} lg={6}>
                  <Margin
                    xs={[0, 0, 36, 0]}
                    sm={[0, 0, 36, 0]}
                    md={[0, 0, 36, 0]}
                    lg={[0, 0, 36, 0]}
                  >
                    <div id="form-container">
                      <TextInput
                        id="rut"
                        label="Rut:"
                        placeholder="Ingresa tu RUT"
                        secondaryLabel=""
                        maxLength={12}
                        value={state.rut}
                        onChange={rutChange}
                        presentation={formatRut}
                        error={
                          state.errors.rut && state.errors.rut.trim() !== ""
                            ? true
                            : false
                        }
                        errorMsg={state.errors.rut}
                      />
                    </div>
                  </Margin>
                </Column>
                <Column xs={4} sm={8} md={6} lg={6}>
                  <Margin
                    xs={[0, 0, 36, 0]}
                    sm={[0, 0, 36, 0]}
                    md={[0, 0, 36, 0]}
                    lg={[0, 0, 36, 0]}
                  >
                    <div id="form-container">
                      <TextInput
                        id="idSerial"
                        label="Nº de serie / Nº de documento:"
                        placeholder="Ej.: A000123399 ó 51223654"
                        secondaryLabel=""
                        maxLength={12}
                        value={state.idSerial}
                        onChange={idSerialChange}
                        presentation={formatIdserial}
                        error={
                          state.errors.idSerial &&
                          state.errors.idSerial.trim() !== ""
                            ? true
                            : false
                        }
                        errorMsg={state.errors.idSerial}
                      />
                    </div>
                  </Margin>
                </Column>
              </Row>
              <Row>
                <Column xs={4} sm={8} md={6} mdOffset={6} lg={5} lgOffset={7}>
                  <Margin
                    xs={[0, 0, 36, 0]}
                    sm={[0, 0, 36, 0]}
                    md={[0, 0, 36, 0]}
                    lg={[0, 0, 36, 0]}
                  >
                    <div>
                      <div className="buttons-mobile align-items--end">
                        <PrimaryButton
                          id="button-next"
                          disabled={
                            (state.errors.rut &&
                              state.errors.rut.trim() !== "") ||
                            state.rut.length < 5 ||
                            (state.errors.idSerial &&
                              state.errors.idSerial.trim() !== "") ||
                            state.idSerial.length < 8 ||
                            !context.checkedStep.stepRut
                              ? true
                              : false
                          }
                          onClick={validateRutClient}
                        >
                          Continuar
                        </PrimaryButton>
                      </div>
                      <div className="buttons-web align-items--end">
                        <ContinueButton
                          id="button-next"
                          disabled={
                            (state.errors.rut &&
                              state.errors.rut.trim() !== "") ||
                            state.rut.length < 5 ||
                            (state.errors.idSerial &&
                              state.errors.idSerial.trim() !== "") ||
                            state.idSerial.length < 8 ||
                            !context.checkedStep.stepRut
                              ? true
                              : false
                          }
                          onClick={validateRutClient}
                        >
                          Continuar
                        </ContinueButton>
                      </div>
                    </div>
                  </Margin>
                </Column>
              </Row>
              <Row>
                <Column>
                  <Margin
                    xs={[0, 0, 36, 0]}
                    sm={[0, 0, 36, 0]}
                    md={[0, 0, 36, 0]}
                    lg={[0, 0, 36, 0]}
                  >
                    <Checkbox
                      id="checkedStepRut"
                      label={
                        <TextBody component="p" type="1">
                          {consent.consent_text}
                        </TextBody>
                      }
                      name="checkedStepRut"
                      checked={context.checkedStep.stepRut}
                      onChange={() =>
                        changeChecked(!context.checkedStep.stepRut)
                      }
                    />
                  </Margin>
                </Column>
              </Row>
            </Column>
          </Row>
        </Grid>
      </div>
    </Fragment>
  );
};

export default RutStep;
